import { render, staticRenderFns } from "./sProtectedAdminField.vue?vue&type=template&id=2c031dfc"
import script from "./sProtectedAdminField.vue?vue&type=script&lang=js"
export * from "./sProtectedAdminField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports